module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "component"
  }, [_c('td', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.component.title))]), _vm._v(" "), _c('td', {
    staticClass: "hours",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.totalHours))]), _vm._v(" "), _c('td', {
    staticClass: "amount",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalHours * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
    staticClass: "amount",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalHours * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Project Management")]), _vm._v(" "), _c('td', {
    staticClass: "hours",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.pmHours))]), _vm._v(" "), _c('td', {
    staticClass: "amount",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.pmHours * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
    staticClass: "amount",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.pmHours * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _vm._l((_vm.itemTypes), function(itemType) {
    return (_vm.component[itemType.value] > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(itemType.label))]), _vm._v(" "), _c('td', {
      staticClass: "hours",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm.component[itemType.value]))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.component[itemType.value] * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.component[itemType.value] * _vm.quoteParams.optionalRate)))])]) : _vm._e()
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.component.sections), function(section) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('td', {
      staticClass: "hours"
    }, [_vm._v(_vm._s(_vm.sectionTotalHours(section)))]), _vm._v(" "), _c('td', {
      staticClass: "hours pm"
    }, [_vm._v(_vm._s(_vm.calcPmHours(section.hours)))]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sectionTotalHours(section) * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
      staticClass: "amount pm"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.calcPmHours(section.hours) * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sectionTotalHours(section) * _vm.quoteParams.optionalRate)))]), _vm._v(" "), _c('td', {
      staticClass: "amount pm"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.calcPmHours(section.hours) * _vm.quoteParams.optionalRate)))])])]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "section"
  }, [_c('td', [_c('strong', [_vm._v("Sections")])]), _vm._v(" "), _c('td', {
    staticClass: "center aligned"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "center aligned"
  }, [_vm._v("PM")]), _vm._v(" "), _c('td', {
    staticClass: "center aligned"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "center aligned"
  }, [_vm._v("PM")]), _vm._v(" "), _c('td', {
    staticClass: "center aligned"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "center aligned"
  }, [_vm._v("PM")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cbb6c28a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/QuoteComponent.vue
// module id = 225
// module chunks = 2